import { render } from "./confirm-button.vue?vue&type=template&id=6a36e766"
const script = {}

import "../common/common-button.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__